import type { StatsSnapshot } from '../../../stats/gameplay-snapshot';
import { useGameStatsStore } from '../../zustand/useGameStatsStore';

export const troupeReducer = (scratch: StatsSnapshot) => {
  const troupe = scratch.generators.troupe;

  // Only update if ticksCount is a multiple of ticksToGenerate
  const ticksToGenerate = troupe.ticksToGenerate ?? 1;
  if (useGameStatsStore.getState().getActiveTicksCount() % ticksToGenerate !== 0) {
    return;
  }

  const generatedBards = troupe.owned * troupe.baseGeneration;

  // Apply upgrades somehow, somewhere...

  scratch.generators.bard.owned += generatedBards;

  return;
};
